import React from "react";
import { RootState } from "Realty/store";
import { connect } from "react-redux";
import { Input } from "../../../../../../components/common/Input";
import "./styles.css";
import { selectContractAssignmentSearchTarget } from "../../../../../../store/ContractAssignment/selectors";
import { ContractAssignmentActionCreator } from "../../../../../../store/ContractAssignment/actions";

const _Search = ({ target, setTarget }) => {
  return (
    <div className="contract-assignment_search-bar">
      <Input
        value={target}
        onChange={setTarget}
        placeholder="поиск по названию"
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  target: selectContractAssignmentSearchTarget(state),
});

const mapDispatchToProps = {
  setTarget: ContractAssignmentActionCreator.setSearchTarget,
};

export const Search = connect(mapStateToProps, mapDispatchToProps)(_Search);
